var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('treeselect',{attrs:{"multiple":true,"options":_vm.options,"placeholder":"Select your favourite(s)..."},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}}),_c('div',{staticClass:"mt-5 ml-1"},[_vm._v(" Selected: "),_c('strong',[_vm._v(_vm._s(_vm.value))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }